module.exports = __webpack_public_path__ + "assets/img/welcome-new.e7189027.png";